import {createEngine} from "./engine";

// One browser engine shared by the practice board and Rook on the front page. It is only downloaded and started the
// first time something asks for it, and it stays alive while you move around the site (searches are queued, so
// sharing is safe).
let engine = null;

export const getSharedEngine = () => {
    if (!engine) engine = createEngine();
    return engine;
};
